// src/components/Clients/ClientSection.js
import React, { useEffect } from 'react';
import { Container, Row, Col} from 'react-bootstrap';import AOS from 'aos';
import 'aos/dist/aos.css';
import './Clients.css'; // Ensure CSS filename matches

// --- IMPORT IMAGES FROM ASSETS ---
import c1 from '../../assets/Clients/1.webp';
import c2 from '../../assets/Clients/2.png';
import c3 from '../../assets/Clients/3.jpg';
import c4 from '../../assets/Clients/4.png';
import c5 from '../../assets/Clients/5.jpg';
import c6 from '../../assets/Clients/6.png';
import c7 from '../../assets/Clients/7.png';
import c8 from '../../assets/Clients/8.png';
import c9 from '../../assets/Clients/9.avif';
import c10 from '../../assets/Clients/10.png';
import c11 from '../../assets/Clients/11.png';
import c12 from '../../assets/Clients/12.png';
import c13 from '../../assets/Clients/13.png';
import c14 from '../../assets/Clients/14.png';
import c15 from '../../assets/Clients/15.png';
import c16 from '../../assets/Clients/16.png';
import c17 from '../../assets/Clients/17.jpg';
import c18 from '../../assets/Clients/18.jpg';
import c19 from '../../assets/Clients/19.png';
import c20 from '../../assets/Clients/20.png';
import c21 from '../../assets/Clients/21.jpg';
import c22 from '../../assets/Clients/22.jpg';
import c23 from '../../assets/Clients/23.png';
import c24 from '../../assets/Clients/24.png';
import c25 from '../../assets/Clients/25.jpg';

const clientImages = [
  c1, c2, c3, c4, c5, c6, c7, c8, c9, c10, 
  c11, c12, c13, c14, c15, c16, c17, c18, c19, c20, 
  c21, c22, c23, c24, c25
];

const ClientSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // 1. Split images into 3 chunks for 3 columns
  const chunk1 = clientImages.slice(0, 9);  // 0-8
  const chunk2 = clientImages.slice(9, 17); // 9-16
  const chunk3 = clientImages.slice(17, 25); // 17-24

  // 2. Helper to render a column with duplicated content for infinite scroll
  const renderColumn = (images, animationClass) => (
    <div className={`marquee-column ${animationClass}`}>
      {/* Original Set */}
      {images.map((img, idx) => (
        <div className="client-card" key={`orig-${idx}`}>
          <img src={img} alt="Client Logo" className="client-logo" />
        </div>
      ))}
      {/* Duplicate Set (Must match exactly for seamless loop) */}
      {images.map((img, idx) => (
        <div className="client-card" key={`dup-${idx}`}>
          <img src={img} alt="Client Logo" className="client-logo" />
        </div>
      ))}
    </div>
  );

  return (
    <section className="client-section" id="clients">
      <Container>
        <Row className="align-items-center">
          
          {/* LEFT: Text Content */}
          <Col lg={7} md={12} className="mb-5 mb-lg-0">
            <div className="client-text-wrapper" data-aos="fade-right">
              <span className="client-label">Our Valuable Clients</span>
              <h2 className="client-heading">
                Trusted by Industry Leaders Worldwide
              </h2>
              <p className="client-desc">
                We are proud to partner with leading automotive OEMs and Tier-1 
                suppliers. Our commitment to precision and reliability has made 
                us the preferred choice for manufacturing partners across the globe.
              </p>
              
             {/*  <Button className="btn-orange-pill">
                View All Clients 
                <span className="btn-icon-circle" style={{marginLeft: '10px'}}>
                  <BsArrowRight />
                </span>
              </Button> */}
            </div>
          </Col>

          {/* RIGHT: Scrolling Wall */}
          <Col lg={5} md={12}>
            <div className="marquee-container" data-aos="fade-left">
              
              {/* Column 1: Scrolls UP */}
              {renderColumn(chunk1, 'col-scroll-up')}

              {/* Column 2: Scrolls DOWN */}
              {renderColumn(chunk2, 'col-scroll-down')}

              {/* Column 3: Scrolls UP */}
              {renderColumn(chunk3, 'col-scroll-up')}
              
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default ClientSection;